module.exports = __webpack_public_path__ + "static/media/gallery-sportcoupe.cde3c19b.jpg";